<template>
	<div id="Dialog">
		<div id="DialogInner" class="Box">
			<div id="DialogInnerTitle" v-if="title">
				<span>{{title}}</span>
			</div>
			<div id="DialogInnerInner">
				<slot/>
			</div>
		</div>
	</div>
</template>

<script>
	import { Component, Vue, Prop } from 'vue-property-decorator';

	@Component({
		components: {
		},
	})
	export default class Dialog extends Vue {
		@Prop(String) title;
	}
</script>

<style lang="scss">
#Dialog {
	height: 100%;
	max-width: 80vw;
	margin: auto;
	
	display: flex;
	align-items: center;
	justify-content: center;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
}
	#DialogInner {
		padding: 0.5vmin;
        min-width: 260px;
	}
		#DialogInnerTitle {
			position: absolute;
			left: 0;
			top: 0;
			right: 0;
			text-align: center;
		}
			#DialogInnerTitle span {
				display: inline-block;
				background: white;
				padding: 0 0.5vmin;
				color: #AEAEAE;			
			}
		#DialogInnerInner {
			border: 3px double white;
			padding: 2vmin;
		}
			#DialogInnerInner p {
				margin-bottom: 1em;
			}
</style>